export default __webpack_public_path__ + "static/media/artist3.7a5edecc.jpg";